module.exports = __webpack_public_path__ + "img/hr-water2.073acd4f.png";